import diff from 'object-diff';

import { Person, SectorNotifications } from 'services/people/types';
import { PersonFormValues, PersonFormIntialValues } from './types';

/**
 * Format payload for creating or updating person
 */
export function formatPersonPayload(
    initialValues: PersonFormIntialValues,
    values: PersonFormValues
): Partial<Person> {
    const wasSprayOperator =
        !values.isSprayOperator && initialValues.isSprayOperator;
    const payload = diff(initialValues, values);
    const { isCertificationPending, sprayCertification } = payload;

    // Delete these attributes, since they are not part of POST/PATCH payload
    delete payload.isSprayOperator;
    delete payload.isCertificationPending;

    // certifications
    if (isCertificationPending) {
        payload.sprayCertification = {};
    } else if (wasSprayOperator) {
        payload.sprayCertification = null;
    } else if (!values.isSprayOperator && sprayCertification) {
        payload.sprayCertification = undefined;
    }

    if (payload.sectorNotifications) {
        payload.sectorNotifications = payload.sectorNotifications.filter(
            (notification: SectorNotifications) =>
                notification.isSubscribedToHarvestEmail ||
                notification.isSubscribedToHarvestSms
        );
    }

    // email and roles. applied for creation only
    if (!values.email && payload.roleIds) {
        payload.roleIds = undefined;
    }

    return payload;
}
